import React, {useEffect, useRef} from 'react';
import CustomerIdInput from 'components/UI/Input/CustomerIdInput';
import PasswordInput from 'components/UI/Input/PasswordInput';
import PrivacyPolicyComponent from 'components/PrivacyPolicy/PrivacyPolicyComponent';
import Button from '@mui/material/Button';
import 'components/LoginForm/LoginForm.css';
import {Form, Link, useActionData, useLocation, useNavigate, useNavigation} from 'react-router-dom';
import {pullConfiguration, signIn} from 'lib/auth-api';
import {Alert, Typography} from '@mui/material';
import T from 'i18n-react';
import {login} from 'lib/utils/loginUtils';

const isTokenExpiredByLocation = (location) => location?.state?.isTokenExpired;

const LoginForm = () => {

    const location = useLocation();
    const data = useActionData();
    const error = data?.exception ? data?.message : null;
    const navigate = useNavigate();
    const navigation = useNavigation();
    const redirectFrom = useRef(location?.state?.from);

    useEffect(() => {
        if (data && !data.exception) {
            login(data);
            if (redirectFrom?.current?.pathname === '/pages/selectedResult') {
                navigate('/pages/selectedResult' + redirectFrom?.current?.search);
            } else {
                navigate('/find-vin');
            }
        }
    }, [data, navigate, redirectFrom]);

    return (
        <div>
            <Typography className="loginText" variant={'h4'}
                        component={'h2'}>{T.translate('loginComponent.loginText')}</Typography>
            {isTokenExpiredByLocation(location) ?
                <Alert severity="warning" className="tokenExpirationMessage" onClose={() => {
                    navigate('/login');
                }}>
                    {T.translate('recoverPasswordComponent.tokenExpired')}
                </Alert> : ''}
            <Form className="loginForm" method={'post'} action={'/login'}>
                <CustomerIdInput isError={!!error}/>
                <PasswordInput isError={!!error}/>
                <Link to={'/request-password'}
                      className="link">{T.translate('recoverPasswordComponent.requestPassword')}</Link>
                {error &&
                    <Alert variant="filled" severity="error">
                        {T.translate('loginComponent.incorrectUserOrPassword')}
                    </Alert>
                }
                <Button
                    className="loginButton"
                    disabled={navigation.state === 'submitting'}
                    variant={'contained'}
                    type={'submit'}
                >{T.translate('loginComponent.login')}</Button>
            </Form>
            <PrivacyPolicyComponent textKey="privacyPolicyComponent.privacyPolicyLoginPage"/>
        </div>
    );
};

export default LoginForm;

export const action = async ({request}) => {
    const formData = await request.formData();
    const customerID = formData.get('customerId');
    const password = formData.get('password');
    try {
        return await signIn(customerID, password)
            .then((response) => {
                login(response.token);
                return response.token;
            }).then(async (token) => {
                await pullConfiguration(token);
                return token;
            });
    } catch (err) {
        return err;
    }
};
